import type { ComponentCommonQuote } from '@edwin-group/people-graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateQuote({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonQuote;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <div
      className={classNames('flex justify-center lg:px-32', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      <div className="flex items-start gap-1">
        <img src="/default-content-template/quote/quote.svg" alt="quote" className="w-5" />
        <div className="text-start">
          <p className="font-haffer text-sh-30-40 font-light text-dark-grey">{component.quote}</p>
        </div>
      </div>
    </div>
  );
}
